// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-advanced-criteria-popup {
  box-sizing: border-box;
  /* Centred on the screener container, not the viewport. Capped at 100% of
     it: anything larger gets clipped by a scrollable ancestor. */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(900px, 100%);
  height: min(900px, 100%);
  box-shadow: 0 0 12px 0 var(--box-shadow-primary, rgba(0, 0, 0, 0.12));
  background-color: var(--surface-primary, #ffffff);
  outline: none;
  overflow: hidden;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid var(--border-primary, #e0e0e0);
  border-radius: 4px;
}

.fund-advanced-criteria-popup-body {
  box-sizing: border-box;
  padding: 16px 24px 0;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.fund-advanced-criteria-popup-select-pane {
  box-sizing: border-box;
  width: 50%;
  height: 100%;
  overflow-y: auto;
  padding-right: 24px;
  border-right: 1px solid #bdbdbd;
}

.fund-advanced-criteria-popup-detail-pane {
  box-sizing: border-box;
  width: 50%;
  height: 100%;
  overflow-y: auto;
  padding-left: 24px;
  padding-right: 12px;
}

.fund-advanced-criteria-popup-footer {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 24px;
  gap: 8px;
  background-color: var(--row-light);
  border-top: 1px solid var(--border-tertiary);
}

.fund-advanced-criteria-popup-button {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 48px;
  margin: 0;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid var(--color-brand);
  background-color: var(--row-light);
  color: var(--color-brand);
  box-shadow: none;
  cursor: pointer;
  &:hover {
    background-color: var(--color-brand-hover2);
  }
}

.fund-advanced-criteria-popup-button-primary {
  border: 1px solid var(--color-brand);
  background-color: var(--color-brand);
  color: var(--text-invert);
  &:hover {
    background-color: var(--color-brand);
    opacity: 0.8;
  }
}

.fund-advanced-criteria-popup-button-primary:disabled {
  border: 1px solid var(--border-secondary);
  background-color: var(--border-secondary);
  color: var(--text-invert);
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/Components/FundScreener/Criteria/FundAdvancedCriteriaPopup/FundAdvancedCriteriaPopup.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB;iEAC+D;EAC/D,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;EACxB,qEAAqE;EACrE,iDAAiD;EACjD,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,YAAY;EACZ,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB;IACE,oCAAoC;IACpC,YAAY;EACd;AACF;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".fund-advanced-criteria-popup {\n  box-sizing: border-box;\n  /* Centred on the screener container, not the viewport. Capped at 100% of\n     it: anything larger gets clipped by a scrollable ancestor. */\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(900px, 100%);\n  height: min(900px, 100%);\n  box-shadow: 0 0 12px 0 var(--box-shadow-primary, rgba(0, 0, 0, 0.12));\n  background-color: var(--surface-primary, #ffffff);\n  outline: none;\n  overflow: hidden;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: 1px solid var(--border-primary, #e0e0e0);\n  border-radius: 4px;\n}\n\n.fund-advanced-criteria-popup-body {\n  box-sizing: border-box;\n  padding: 16px 24px 0;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n}\n\n.fund-advanced-criteria-popup-select-pane {\n  box-sizing: border-box;\n  width: 50%;\n  height: 100%;\n  overflow-y: auto;\n  padding-right: 24px;\n  border-right: 1px solid #bdbdbd;\n}\n\n.fund-advanced-criteria-popup-detail-pane {\n  box-sizing: border-box;\n  width: 50%;\n  height: 100%;\n  overflow-y: auto;\n  padding-left: 24px;\n  padding-right: 12px;\n}\n\n.fund-advanced-criteria-popup-footer {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  padding: 24px;\n  gap: 8px;\n  background-color: var(--row-light);\n  border-top: 1px solid var(--border-tertiary);\n}\n\n.fund-advanced-criteria-popup-button {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 48px;\n  margin: 0;\n  padding: 0 16px;\n  border-radius: 4px;\n  border: 1px solid var(--color-brand);\n  background-color: var(--row-light);\n  color: var(--color-brand);\n  box-shadow: none;\n  cursor: pointer;\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n}\n\n.fund-advanced-criteria-popup-button-primary {\n  border: 1px solid var(--color-brand);\n  background-color: var(--color-brand);\n  color: var(--text-invert);\n  &:hover {\n    background-color: var(--color-brand);\n    opacity: 0.8;\n  }\n}\n\n.fund-advanced-criteria-popup-button-primary:disabled {\n  border: 1px solid var(--border-secondary);\n  background-color: var(--border-secondary);\n  color: var(--text-invert);\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
